export default __webpack_public_path__ + "34e439e749cbf91a66fd0356fcdbb4e4.jpg";